import './MainSectionText.sass'

export function MainSectionText (props) {
  return <div className="main-section-text">
    <pre>{props.text}</pre>
  </div>
}
